module.exports = __webpack_public_path__ + "img/Cerebro.cd21a429.svg";